import { buildURI, useFetch } from '@hn-front/utils';
import { useMemo } from 'react';
import { YEARLY_REPORT_API } from '../../constants/routes';
import { adaptYearlyDashboardToClient } from './adapter';
var useFetchYearlyDashboardData = function (groupId, _a) {
    var role = _a.role, schoolId = _a.schoolId;
    var memoizedUrl = useMemo(function () {
        return groupId
            ? buildURI(YEARLY_REPORT_API.dashboardData, {
                pathParams: { groupId: groupId },
                query: { role: role, school_id: schoolId },
            })
            : undefined;
    }, [groupId, role, schoolId]);
    return useFetch(memoizedUrl, {
        isCache: false,
        adapter: adaptYearlyDashboardToClient,
    });
};
export { useFetchYearlyDashboardData };
